module.exports = __webpack_public_path__ + "img/UFO.e9f89a57.svg";